import { everest } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

export const postTicketNextStage = async (
  ticketId: Uuid,
): Promise<{ data: Object[] }> => {
  return everest.post(`/tickets/${ticketId}/next-stage`);
};
